import { useTranslation } from 'react-i18next';

import { useSeriesWatchtime } from '../../utils/useSeriesWatchtime';
import { useDefaultEpisode } from '../../utils/useDefaultEpisode';
import { useAppSelector } from '../../../modules/hooks';
import { selectEpisodeById } from '../../../modules/assets';
import { getPath, routeNames } from '../../../shared/helpers/routes';
import { useAssetWatchtimeData } from '../../utils/useAssetWatchtimeData';

import type { Vendor } from '../../../types';
import type { SvpCategoryAdditional } from '@vgtv/api-client/lib/svp_category';

function useEpisodeData({
  category,
  vendor,
  urlProp,
}: {
  vendor: Vendor;
  urlProp?: string;
  category: SvpCategoryAdditional;
}) {
  const { t } = useTranslation();

  const { watchtime } = useSeriesWatchtime({
    categoryId: category.id,
    vendor,
  });
  const { data: defaultEpisode } = useDefaultEpisode({
    category,
    vendor,
  });

  const asset =
    useAppSelector((state) =>
      selectEpisodeById(state, vendor, watchtime?.assetId)
    ) ?? defaultEpisode;

  const { position } = useAssetWatchtimeData(asset?.id, asset?.provider);

  if (!asset) {
    return {};
  }

  return {
    label: `${t('Season')} ${asset.series?.seasonNumber ?? 1} · ${t('Episode')} ${
      asset.series?.episodeNumber ?? 1
    }`,
    episodeUrl:
      urlProp ||
      getPath(routeNames.asset, {
        asset,
        time: position,
      }),
    asset,
  };
}

export { useEpisodeData };
